import { Helmet } from "react-helmet";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import QuickQuoteCalculator from "@/components/QuickQuoteCalculator";

const QuickQuote = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Quick Quote Calculator | Rick's Black Car Service</title>
        <meta name="description" content="Get an instant quote for your luxury car service in San Antonio. Calculate your fare for airport transfers, corporate travel, and special events." />
      </Helmet>
      
      <Navbar />
      
      <main className="container mx-auto px-4 pt-24 pb-20">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
              Quick Quote Calculator
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Get an instant estimate for your premium black car service. 
              Simply enter your trip details and receive a detailed price breakdown.
            </p>
          </div>

          <QuickQuoteCalculator />

          <div className="mt-12 text-center space-y-4">
            <div className="bg-muted/50 rounded-lg p-6 max-w-2xl mx-auto">
              <h2 className="text-xl font-semibold mb-3 text-foreground">Pricing Details</h2>
              <div className="text-sm text-muted-foreground space-y-2 text-left">
                <p>• <strong>Base Fee:</strong> $55.00</p>
                <p>• <strong>Per Mile:</strong> $3.45</p>
                <p>• <strong>Minimum Fare:</strong> $85.00</p>
                <p>• <strong>Gratuity:</strong> 20% (automatically included)</p>
                <p>• <strong>Late Night Fee:</strong> $20.00 (11:00 PM - 5:00 AM)</p>
                <p>• <strong>Austin Airport (AUS):</strong> $395.00 flat rate</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default QuickQuote;
